import React from "react";

/**
 * KPI stat card — two variants:
 *
 * Variant "icon"  (default):  icon + large number + label
 *   Props: icon, iconBg, iconColor, value, label, delta
 *
 * Variant "simple":  label on top, large coloured number below
 *   Props: label, value, color (tailwind text-* class)
 */
const KpiCard = ({
  // icon variant
  icon: Icon,
  iconBg,
  iconColor,
  delta,
  // shared
  value,
  label,
  // simple variant
  color,
  // style
  className = "",
}) => {
  const isSimple = !Icon;

  if (isSimple) {
    return (
      <div className={`flex flex-col gap-1 bg-white border border-surface-border rounded-xl px-5 py-4 min-w-[130px] ${className}`}>
        <p className="text-xs text-brand-muted">{label}</p>
        <p className={`text-2xl font-bold ${color || "text-brand-text"}`}>{value}</p>
      </div>
    );
  }

  return (
    <div className={`bg-white border border-surface-border rounded-2xl p-5 flex flex-col gap-3 ${className}`}>
      <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${iconBg}`}>
        <Icon className={`w-5 h-5 ${iconColor}`} />
      </div>
      <div>
        <p className="text-2xl font-bold text-brand-text">{value}</p>
        <p className="text-sm text-brand-muted mt-0.5">{label}</p>
        {delta && <p className="text-xs font-medium text-emerald-500 mt-1">{delta}</p>}
      </div>
    </div>
  );
};

export default KpiCard;
